import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  HireDispatcherInitialValues,
  HireDispatcherInterface,
} from '../../models/dashboard/driver-lookup/hire-dispatcher';

interface IInitialState {
  hireDispatcherData: HireDispatcherInterface;
}
const initialState: IInitialState = {
  hireDispatcherData: HireDispatcherInitialValues,
};

const hireDispatcherSlice = createSlice({
  name: 'hireDispatcherSlice',
  initialState,
  reducers: {
    setHireDispatcherSlider(state, action: PayloadAction<HireDispatcherInterface>) {
      state.hireDispatcherData = action.payload;
    },
  },
});

export const hireDispatcherAction = hireDispatcherSlice.actions;
export default hireDispatcherSlice.reducer;
